document.addEventListener("DOMContentLoaded", showSlides);

function currentSlide(n) {
  showSlides((slideIndex = n));
}

let slideIndex = 0;

function showSlides() {
  let pairs = [];
  let slides = document.getElementsByClassName("mySlides");
  let dots = document.getElementsByClassName("dot");

  for (let i = 0; i < slides.length; i += 3) {
    let pair = [slides[i], slides[i + 1], slides[i + 2]];
    pairs.push(pair);
  }

  pairs.forEach((pair) => {
    for (let i = 0; i < pair.length; i++) {
      if (i < 2) {
        pair[i].style.display = "none";
        pair[i + 1].style.display = "none";
      } else {
        pair[i].style.display = "none";
        pair[0].style.display = "none";
      }
    }
  });

  for (let i = 0; i < dots.length; i++) {
    dots[i].style.backgroundColor = "#ffffff85";
  }

  slideIndex++;

  if (slideIndex > 3) {
    slideIndex = 1;
  }

  pairs.forEach((pair) => {
    pair[slideIndex - 1].style.display = "flex";
  });

  let dotContainer = document.querySelectorAll("#dot-container");
  dotContainer.forEach((dot) => {
    for (let i = 0; i < dot.children.length; i++) {
      dot.children[slideIndex - 1].style.backgroundColor = "#ffffff";
    }
  });
}

setInterval(showSlides, 4000);
